/**
 * [微企收款管理]
 * @author: Fu Xiaochun
 * @date: 2021-09-03 
 */

import http from '@/assets/api/http';

// 收款单列表
export async function collectionOrderList(params){
    return http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReceiptService.queryReceiptList',params,'POST');
}

// 确认收款
export async function confirmCollectionOrder(params){
    return http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReceiptService.confirmReceipt',params,'POST');
}

// 收款单详情
export async function getCollectionOrderDetail(params){
    return http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReceiptService.queryReceiptDetail',params,'POST');
}

// 微企列表
export async function microBusinessList(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.getMepPair',params,'POST');
}

// 微企详情
export async function microBusinessDetail(params){
    return http('/?cmd=com.xqxc.api.pig.microep.account.MicroAcMepUserInfoService.getMepPairDetailById',params,'POST');
}

// 创建收款单
export async function addCollectionOrder(params){
    return http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReceiptService.newReceipt',params,'POST');
}

// 更新收款单
export async function updateCollectionOrder(params){
    return http('/?cmd=com.xqxc.api.pig.microep.reconciliation.MicroEpReceiptService.updateReceipt',params,'POST');
}
